import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ScheduleEvent } from '../../../shared/models/ScheduleModels';
import { MatDialog } from '@angular/material/dialog';
import { GameEventDetailsDialogComponent, GameEventDetailsDialogResult } from '../../../shared/components/game-event-details-dialog/game-event-details-dialog.component';
import { Router } from '@angular/router';


@Component({
  selector: 'app-game-event',
  imports: [DatePipe],
  templateUrl: './game-event.component.html',
  styleUrl: './game-event.component.css'
})
export class GameEventComponent implements OnInit {
  @Input() Event!: ScheduleEvent;
  @Output() deleteEvent = new EventEmitter<string>();
  localEventStart: Date;

  constructor(private dialog: MatDialog, private router: Router) {}

  ngOnInit() {
    // Convert UTC string to local Date object
    this.localEventStart = this.Event.EventStartUTC;
  }

  private convertUTCToLocal(utcDate: any): Date {
    if (!utcDate) return new Date();

    // If it's already a Date, return it
    if (utcDate instanceof Date) return utcDate;

    // If it's a string, ensure it's treated as UTC
    const dateStr = utcDate.toString();
    // Add 'Z' if not present to indicate UTC
    if (!dateStr.endsWith('Z') && !dateStr.includes('+')) {
      return new Date(dateStr + 'Z');
    }
    return new Date(dateStr);
  }

  openGameDetails(): void {
    if (!this.Event) {
      return;
    }

    const dialogRef = this.dialog.open(GameEventDetailsDialogComponent, {
      maxWidth: '520px',
      width: '92vw',
      panelClass: 'event-details-dialog',
      data: this.Event,
    });

    dialogRef.afterClosed().subscribe((result: GameEventDetailsDialogResult | undefined) => {
      if (result?.action === 'delete' && result.eventId) {
        this.deleteEvent.emit(result.eventId);
      } else if (result?.action === 'viewGame' && result.gameId) {
        this.router.navigate(['/games', result.gameId]);
      }
    });
  }
}
